/**
 * Claims minted by infrastructure/auth0/actions/add-portal-member-claims.js.
 *
 * Constants, not environment settings: they are a contract with that Action,
 * identical in every environment. Namespaced URIs, or Auth0 silently drops them.
 */
export const MEMBER_CLAIMS = {
  /** The member's roles in THIS organization: customer-admin, customer-member. */
  orgRoles: "https://davaco.com/org_roles",
  /** True while the user holds an admin-issued temporary password. */
  mustChangePassword: "https://davaco.com/must_change_password",
} as const;

/** The organization role that manages members. */
export const CUSTOMER_ADMIN_ROLE = "customer-admin" as const;
